import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { EstablishmentsForCategorieResponse } from "../interface/establishments-for-categorie.interface";
import { NavigateEstablishment } from "../../../core/interfaces/navigate-for-categorie-establishment/navegiate-for-categorie.establishment.service";
import { Observable } from "rxjs";
import { AuthService } from "../../../core/service/auth.service";

@Injectable({
  providedIn: 'root'
})

export class EstablishmentsForCategorieService {
  private readonly apiUrl = environment.apiUrl;
  constructor(private http: HttpClient,
    private authService: AuthService
  ) {

  }

  loadEstablishmentsForType(NavigateEstablishmentRequest: NavigateEstablishment): Observable<EstablishmentsForCategorieResponse> {

    if (this.authService.isLoggedIn()) {
      // console.log('token', this.authService.getToken());
      const tokenUser = this.authService.getToken();
      const headers = new HttpHeaders({
        'Authorization': `Bearer ${tokenUser}`,
        'Content-Type': 'application/json'
      });
      return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/type_establishments`, NavigateEstablishmentRequest, { headers })
    }
    return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/type_establishments`, NavigateEstablishmentRequest)
  }
}
